package ir.yusefpasha.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.graphics.Image
import ir.yusefpasha.util.Res
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun RatingBar(
    modifier: Modifier = Modifier,
    rating: Int = 5
) {
    Row(modifier = modifier) {
        repeat(rating) {
            Image(
                modifier = Modifier.size(16.px).margin(right = if (it != 4) 2.px else 0.px),
                src = Res.Icon.STAR,
                desc = "Star Icon"
            )
        }

        if (rating != 5) {
            val unRate = rating.minus(5)
            repeat(unRate) {
                Image(
                    modifier = Modifier.size(16.px).margin(left = if (it != unRate) 2.px else 0.px).opacity(30.percent),
                    src = Res.Icon.STAR,
                    desc = "Star Icon"
                )
            }
        }
    }
}